import { render, staticRenderFns } from "./NoConformidades.vue?vue&type=template&id=7a2d2642&"
import script from "./NoConformidades.vue?vue&type=script&lang=js&"
export * from "./NoConformidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports